import {Injectable} from "@angular/core";
import {environment} from "../../../environments/environment";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Params} from "@angular/router";

@Injectable({
  providedIn: 'root',
})

export class CivMainService {

  constructor(private readonly http: HttpClient) {
  }

  getTokensFromBackend(listOfCustomerId: string, parentCustomerId: string,contactMomentId: string) {
    const civServicesBaseURL = environment.civServicesBaseURL;
    const body = {
      "listOfCustomerId": listOfCustomerId,
      "parentCustomerId": parentCustomerId,
      "contactMomentId": contactMomentId
    }

    const headers = this.createHeaders();

    return this.http.post(civServicesBaseURL + "get-auth-tokens", body, {headers});
  }

  createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    headers = headers.append('Content-type', 'application/json');
    return headers;
  }

}
